export enum AppRoutes {
  DASHBOARD = 'admin-dashboard',
  ACCESS_DENIED = 'admin-access-denied',
}
